import * as React from 'react';
import type { TabsComposition } from '@components/moleculs/tabs/types';
import type { TabsProps } from '@mui/material/Tabs';

import { TabsContainer } from './styles';
import { Tab } from './tab';
import { TabPanel } from './tab-panel';

export { Tab } from './tab';
export { TabPanel } from './tab-panel';

export const Tabs: React.FC<TabsProps> & TabsComposition = (props) => <TabsContainer {...props} />;

Tabs.TabPanel = TabPanel;
Tabs.Tab = Tab;
